import { svg } from "../svg";

export const VowkeyIcon = svg`
  <svg width="56" height="56" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
    <rect x="1" y="1" width="118" height="118" rx="27" style="fill: var(--vk-surface, #FFFFFF); stroke: var(--vk-line, #E2E0DA); stroke-width: 2"/>
    <g transform="translate(60 61) scale(0.86) translate(-60 -57)">
      <path d="M70 40H93a9 9 0 0 1 9 9v28a9 9 0 0 1-9 9H27a9 9 0 0 1-9-9V49a9 9 0 0 1 9-9h1" fill="none" stroke-width="7" stroke-linecap="round" style="stroke: var(--vk-ink, #121216)"/>
      <rect x="31" y="28" width="34" height="23" rx="5" style="fill: var(--vk-blue, #2563EB)"/>
      <rect x="37.5" y="37.75" width="21" height="3.5" rx="1.75" fill="#fff"/>
      <g style="fill: var(--vk-ink, #121216)"><circle cx="35" cy="65" r="5"/><circle cx="51" cy="65" r="5"/><circle cx="67" cy="65" r="5"/></g>
      <rect x="80" y="54" width="5.5" height="22" rx="2.75" style="fill: var(--vk-blue, #2563EB)"/>
    </g>
  </svg>
`;
